import { useEventCallback } from '@mui/material';
import { Fragment, ReactElement } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useNavigate, useParams } from 'react-router-dom';
import { DetailTypeOperationCrubs } from 'practice/constants/type-operation-crubs';
import FormTypeOperation, { FormTypeOperationVM } from 'practice/components/type-operation/form';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { TypeOperationData } from 'shell/models/type-operation';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { typeOperationResponseTransformer } from 'practice/utils/typeoperation-response-transformer';

const DetailTypeOperation = (): ReactElement => {
  const navigate = useNavigate();

  const onCancel = useEventCallback(() => {
    navigate('/pratiche/ricerca-tipo-operazione');
  });

  const params = useParams();

  const [typeOperation] = useHttpFetch<HttpResponse<TypeOperationData>, FormTypeOperationVM>(
    `${__PRACTICE_API_URL__}/pratiche/tipo-operazione/${params?.tyPratica}/${params?.tyOperazione}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {
          key: {
            tipoPratica: params?.tyPratica,
            tipoOperazione: params?.tyOperazione,
            codiceEnte: params?.code,
          },
        },
      },
      transformer: typeOperationResponseTransformer,
    }
  );

  return (
    <Fragment>
      <Breadcrumbs items={DetailTypeOperationCrubs} />
      {typeOperation.isLoading || typeOperation.pristine || typeOperation.hasErrors ? undefined : (
        <FormTypeOperation
          title="Dettaglio Tipo Operazione"
          onCancel={onCancel}
          disabled
          initialValues={typeOperation?.data as FormTypeOperationVM}
        />
      )}
    </Fragment>
  );
};

DetailTypeOperation.displayName = 'Detail Type Practice Page component';

export default DetailTypeOperation;
